.scoreCard {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: white;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin: 8px 0;
}

.icon {
    font-size: 20px;
    font-weight: bold;
}

.scoreText {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.scoreNumber {
    font-family: Hanken Grotesk;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
}

.scoreLabel {
    font-family: Hanken Grotesk;
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
} 